import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelDialog from '../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../../components/voxel/Text/VoxelText';
import { ContentTaskGq } from '../../../../graphql/projects/models/ContentTaskGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';

export interface ContentUrlAddAllDialogProps {
  contentTask: ContentTaskGq;
  clientUrl: string;
  searchKeywordCount: number;
  searchTerm: string;
  reload: () => Promise<any>;
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
}

const ContentUrlAddAllDialog: React.FC<ContentUrlAddAllDialogProps> = ({
  contentTask,
  clientUrl,
  searchKeywordCount,
  searchTerm,
  reload,
  openDialog,
  setOpenDialog,
}) => {
  const [updating, setUpdating] = useState(false);

  const taskUrl = (contentTaskUrl: string) => {
    const urlIndex = contentTaskUrl.indexOf(clientUrl) + (clientUrl?.length ?? 0);
    const urlSnippet = contentTaskUrl?.substring(Math.max(urlIndex, 0));
    const start = urlSnippet.startsWith('/') || urlSnippet.startsWith('http') ? '' : '/';
    return start + urlSnippet;
  };

  const searchKeywordQuery = projectsApiService.queries.useGetContentTaskKeywords({
    searchTerm,
    projectId: contentTask.projectId,
    rowsPerPage: searchKeywordCount,
    page: 0,
    excludeTaskId: contentTask.id,
  });

  const searchKeywords = searchKeywordQuery?.contentTaskKeywords;

  // Mutation
  const addMutation = projectsApiService.mutations.contentPlan.useAddTaskKeywords();
  const handleAddKeywords = () => {
    if (!searchKeywords?.length) return;

    setUpdating(true);
    addMutation({
      projectId: contentTask.projectId,
      sourceContentKeywordIds: searchKeywords?.map((i) => i.id) ?? [],
      destinationContentTaskId: contentTask.id,
      destinationOrderKeywordIds: contentTask.keywords.map((k) => k.id),
      insertByVolumeOrder: true,
    })
      .then(() => Promise.all([reload()]))
      .finally(() => {
        setUpdating(false);
        setOpenDialog(false);
      });
  };

  return (
    <VoxelDialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      title="Add all keywords from search result"
    >
      <VoxelDialogContent>
        <VoxelText>
          Are you sure you want to move{' '}
          <span className="font-bold">{searchKeywordCount} keywords </span> to the{' '}
          <span className="font-bold">{taskUrl(contentTask.url)}</span> url?
        </VoxelText>
      </VoxelDialogContent>

      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={() => setOpenDialog(false)} />
        <VoxelDialogActionSubmit
          endIcon={<FontAwesomeIcon icon={faCheck} />}
          title={'Add all'}
          onClick={handleAddKeywords}
          disabled={updating}
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default ContentUrlAddAllDialog;
